import ProductFeature from "./block-color-content.jsx";
import { h, render } from "preact";

class SectionProductColorFeature extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.carousel = this.querySelector("[data-block-color-feature]");
    this.init();
  }

  init() {
    const { products, collection } = this.data;
    const swiperParams = {
      scrollbar: {
        draggable: true,
      },
      spaceBetween: 0,
      speed: 200,
      slidesPerView: "auto",
      slidesPerGroup: 1,
      grid: {
        rows: 1,
      },
      centerInsufficientSlides: true,
      mousewheel: {
        forceToAxis: true,
      },
    };

    render(<ProductFeature ids={products} />, this.carousel);
  }
}

if (!customElements.get("block-product-color-feaure")) {
  customElements.define(
    "block-product-color-feature",
    SectionProductColorFeature
  );
}
